export enum ImportType {
    Kluwer = 'KLUWER',
    TaxOnWeb = 'TAX_ON_WEB',
    Sofisk = 'SOFISK',
    Csv = 'CSV',
}
export function getLocalizedImportTypes(): Record<ImportType, string> {
    return {
        KLUWER: 'Kluwer',
        TAX_ON_WEB: 'Tax-on-web',
        SOFISK: 'Sofisk',
        CSV: 'CSV',
    };
}
